import { Button } from '../../../components/common/Button/Button';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { DASHBOARD } from '../../../routes/routes';

import { Icon, IconApproveNFTSuccess } from '../../../styles/Icons';

import { P1, P2 } from '../../../styles/FontStyles';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Dispatch, SetStateAction } from 'react';
import { flipMeGetInfo } from '../../FlipMeWallet/FlipMeWallet.actions';

interface Step3Props {
  packageId: number | null | undefined;
  setRedeemCardsModal: Dispatch<SetStateAction<boolean>>;
}

export const Step3 = ({ packageId, setRedeemCardsModal }: Step3Props) => {
  const { isPersonalFlipmeRedeemRequired } = useAppSelector(
    (state) => state.wallets
  );
  const dispatch = useAppDispatch();

  return (
    <Box>
      <Flexed column center>
        <Icon>
          <IconApproveNFTSuccess />
        </Icon>

        <P2 bold mt='30' mb='30' center>
          {isPersonalFlipmeRedeemRequired
            ? 'The user you gifted the FlipMe card to will see it available in their app soon.'
            : 'Card activation complete. Your FlipMe card will be available soon in the app.'}
        </P2>
      </Flexed>

      {packageId ? (
        <Flexed column center>
          <Link to={DASHBOARD}>
            <Button w='200px' negative onClick={() => {}}>
              Back to Dashboard
            </Button>
          </Link>
        </Flexed>
      ) : (
        <Flexed column center>
          <Button
            w='200px'
            negative
            onClick={() => {
              setRedeemCardsModal(false);
              dispatch(flipMeGetInfo());
            }}>
            Back to Dashboard
          </Button>
        </Flexed>
      )}
    </Box>
  );
};
